// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .blissey .hotels-list__hotel:not(:last-child) {\n            border-bottom: 1px solid var(--special-color);\n        }", ""]);
// Exports
module.exports = exports;
